export interface ApiGetClaimCompareMatchRequest {
    source_text: string;
    source_patent: string;
    source_lang: string;
    target_type: string;
}

export interface ApiGetClaimCompareMatchResponse {
    match_text: string[];
}

export const GetClaimCompareMatch = Symbol.for('GetClaimCompareMatch');

export interface GetClaimCompareMatch {
    getClaimCompareMatch(request: ApiGetClaimCompareMatchRequest): Promise<ApiGetClaimCompareMatchResponse>;
}
